import { JobSiteFormData } from '../types/JobSiteTypes';
import { mapFormDataToCreateInput } from '../mappers/JobSiteMappers';
import { useCreateJobSiteMutation } from '@/common/infrastructure/gql/generated/schema';
interface CreateJobSiteResult {
  data?: {
    id: number | null;
    jobSiteName: string | null;
    address: string | null;
    latitude?: number | null;
    longitude?: number | null;
  };
  isSuccess?: boolean;
}

export const useCreateJobSite = () => {
  const [createJobSite, { data, loading, error }] = useCreateJobSiteMutation();

  const handleCreateJobSite = async (formData: JobSiteFormData): Promise<CreateJobSiteResult> => {
    try {
      const mutationInput = mapFormDataToCreateInput(formData);
      const { data } = await createJobSite({
        variables: { input: mutationInput },
        refetchQueries: ['listJobSites'],
        awaitRefetchQueries: true
      });
      const createJobSiteResult = data?.createJobSite;
      return {
        data: {
          id: createJobSiteResult?.value?.id ?? null,
          jobSiteName: createJobSiteResult?.value?.jobSiteName ?? null,
          address: createJobSiteResult?.value?.address ?? null,
          latitude: createJobSiteResult?.value?.latitude ?? null,
          longitude: createJobSiteResult?.value?.longitude ?? null
        },
        isSuccess: createJobSiteResult?.isSuccess
      };
    } catch (err) {
      console.error('Error creating jobSite:', err);
      throw err;
    }
  };

  return { handleCreateJobSite, data, loading, error };
};
